import { atom } from 'recoil';

export const disabledState = atom({
  key: 'disabledState',
  default: false,
});
